// @flow

import * as React from 'react'
import { DndProvider } from 'react-dnd-cjs'
import HTML5Backend from 'react-dnd-html5-backend-cjs'

export default ({ children }: { children: React.Node }) => (
  <DndProvider backend={HTML5Backend}>{children}</DndProvider>
)
